<footer id="footer" class="fadeIn def_back">
  <span>Copyright &copy; {new Date().getFullYear()} obyte.it. All rights reserved.
    <a id="footer-privacy-link" href="https://tools.obyte.it/public/docs/privacy_policy_en.html" target="_blank" rel="noopener noreferrer">
      Privacy
    </a>
    <br/>Optimized for all the major browsers.
  </span>
</footer>


<style type="text/scss">
  @import '../../public/styles/variables';
  @import '../../public/styles/mixins';

  /** Footer */
  #footer {
    display: block;
    width: 100%;
    height: 100px;
    box-sizing: border-box;
    margin: 0 auto;
    padding: 30px 0 30px;
    color: #999;
    font-size: $font-size-s;
    clear: both;
    text-align: center;
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    #footer-privacy-link {
      &:hover { text-decoration: underline; }
    }
  }
</style>